import apiRequest from "../../helpers/apiRequest";

export default async (data) => {
    return await apiRequest({
        method: 'post',
        url: `content/submit/for/review`,
        data: data
    })
}
